module.exports = __webpack_public_path__ + "static/media/main idea.acf747ff.mp3";